import { Platform, StyleSheet } from 'react-native'
import { theme } from '../../../theme'

export const legalReconsentGateStyles = StyleSheet.create({
  // Without an explicit width the content wrapper sizes to its text, so on Android a long body
  // line pushed the sheet (plus this padding) past the screen edge.
  modalOuter: {
    width: '100%',
    alignItems: 'center',
    paddingHorizontal: 16,
  },
  // Same dark card as the age prompt. theme.gray[900] is near-white in the dark-only palette,
  // which made the white title invisible.
  sheet: {
    backgroundColor: theme.gray[50],
    borderColor: theme.gray[200],
    borderWidth: 1,
    borderRadius: 16,
    ...(Platform.OS === 'android' ? { elevation: 8 } : {}),
    padding: 24,
    gap: 12,
    maxWidth: 420,
    width: '100%',
    alignSelf: 'center',
  },
  title: {
    fontSize: 20,
    fontWeight: '700',
    color: theme.white,
  },
  body: {
    fontSize: 15,
    lineHeight: 22,
    color: theme.gray[500],
  },
  linkRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    columnGap: 16,
    marginTop: 4,
  },
  link: {
    paddingVertical: 4,
  },
  linkText: {
    fontSize: 15,
    fontWeight: '600',
    color: theme.primary,
    textDecorationLine: 'underline',
  },
  error: {
    fontSize: 14,
    color: theme.error,
  },
  // Stacked, primary on top: side by side, "Decline and sign out" + Accept do not fit a
  // 360dp phone and wrapped into a lopsided layout.
  actions: {
    flexDirection: 'column-reverse',
    alignItems: 'stretch',
    gap: 4,
    marginTop: 8,
  },
  declineButton: {
    paddingVertical: 12,
    alignItems: 'center',
  },
  declineText: {
    fontSize: 15,
    fontWeight: '600',
    color: theme.gray[500],
  },
  acceptButton: {
    backgroundColor: theme.primary,
    borderRadius: 10,
    paddingVertical: 12,
    paddingHorizontal: 20,
    alignItems: 'center',
    justifyContent: 'center',
  },
  acceptButtonDisabled: {
    opacity: 0.6,
  },
  acceptText: {
    fontSize: 15,
    fontWeight: '700',
    color: theme.white,
  },
})
